interface Props {
  id?: string;
  children?: React.ReactNode;
}

export const CellRenderer = ({ id, children }: Props): JSX.Element => (
  <div className="w-full overflow-hidden overflow-ellipsis h-full" id={id}>
    {children}
  </div>
);
